import React from "react";
import { useNavigate } from 'react-router-dom';
import HeaderwideImg from './images/heroimg.gif';

const HeroSection = () => {
  const navigate = useNavigate();

  const CleanLayoutCSS = (
    <style>{`
      /* --- DESKTOP VIEW ONLY (769px and up) --- */
      @media (min-width: 769px) {
        .hero-responsive {
          background-size: cover !important;
          background-position: center center !important;
          height: 100vh !important;
        }
        .cta-container-responsive {
          flex-direction: column !important; /* Nakapila pababa gaya ng gusto mo */
          align-items: center !important;
          width: 100% !important;
        }
        .btn-responsive {
          width: 100% !important;
          max-width: 450px !important; /* Kasya yung mahabang text sa desktop */
        }
      }

      /* --- MOBILE VIEW ONLY (768px and below) --- */
      @media (max-width: 768px) {
        .hero-responsive {
          /* Eto ang kailangan para mag-fit ang buong image sa screen width */
          background-size: 100% auto !important; 
          background-position: top center !important;
          background-repeat: no-repeat !important;
          background-color: #000 !important; /* Para black pa rin ang background kung bitin ang height */
          min-height: 100vh !important;
          display: flex !important;
          align-items: center !important;
        }
        .content-responsive {
          /* Ibaba natin ang content para hindi matakpan ang focus ng GIF sa taas */
          padding-top: 180px !important; 
          padding-bottom: 20px !important;
        }
        .cta-container-responsive {
          flex-direction: column !important;
          align-items: center !important;
          gap: 10px !important;
        }
        .btn-responsive {
          width: 90% !important; /* Para hindi dikit sa edge ng phone */
          max-width: 300px !important;
        }
      }
    `}</style>
  );

  return (
    <>
      {CleanLayoutCSS} 
      <section style={styles.hero} className="hero-responsive">
        <div style={styles.overlay}></div>

        <div style={styles.content} className="content-responsive">
          <h1 style={styles.title}><strong>Albiemer Porte</strong></h1>
          <h2 style={styles.role}><strong>Embedded & Software Systems Developer</strong></h2>
          
          <p style={styles.subtitle}>
            <strong>
              I design and build complete systems that integrate hardware, embedded devices, and full-stack software.
            </strong>
          </p>

          <div style={styles.ctaButtons} className="cta-container-responsive">
             <button style={{ ...styles.btn, ...styles.primaryBtn }} className="btn-responsive">
                <a style={styles.linkText} href="/Non-ats-Resume-Albiemer Porte.pdf" download>
                  Download Resume
                </a>
             </button>

             <button style={{ ...styles.btn, ...styles.primaryBtn }} className="btn-responsive" onClick={() => navigate("/project")}>
                Repository & Tutorials
             </button>
             
             <button
                className="seemore btn-responsive"
                style={{ ...styles.btn, ...styles.secondaryBtn }}
                onClick={() => navigate("/about")}
             >
                Hire Me To Unlock My Full Potential
             </button>
          </div>
        </div>
      </section>
    </>
  );
};

const styles = {
  hero: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
    width: "100%",
    textAlign: "center",
    backgroundImage: `url(${HeaderwideImg})`,
    backgroundColor: "#000",
    overflow: "hidden",
  },
  overlay: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "linear-gradient(135deg, rgba(0,15,30,0.7), rgba(0,0,0,0.5))",
    zIndex: 1,
  },
  content: {
    position: "relative",
    zIndex: 2,
    padding: "20px",
    width: "100%",
    maxWidth: "900px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  title: {
    fontSize: "clamp(2rem, 10vw, 4.5rem)", 
    marginBottom: "10px",
    fontWeight: "900",
    background: "linear-gradient(90deg, #0ff, #fff)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    lineHeight: "1.1",
  },
  role: {
    fontSize: "clamp(1rem, 5vw, 1.8rem)",
    fontWeight: "600",
    color: "#0ff",
    marginBottom: "15px",
  },
  subtitle: {
    fontSize: "clamp(0.9rem, 4vw, 1.1rem)",
    color: "#ccc",
    marginBottom: "25px",
    lineHeight: "1.4",
    maxWidth: "600px",
  },
  ctaButtons: {
    display: "flex",
    gap: "15px",
  },
  btn: {
    padding: "12px 25px",
    fontSize: "0.95rem",
    borderRadius: "8px",
    fontWeight: 600,
    cursor: "pointer",
    border: "none",
    transition: "0.3s",
  },
  primaryBtn: {
    backgroundColor: "#00f",
    color: "#fff",
  },
  secondaryBtn: {
    backgroundColor: "transparent",
    border: "2px solid #0ff",
    color: "#0ff",
  },
  linkText: {
    textDecoration: "none",
    color: "inherit",
    display: "block",
  }
};

export default HeroSection;